export class SchedulingTransport {
    id!: string
    priority!: number
    requestedById!: number
    description!: string
    fromJob!: string
    toJob!: string
    dueDate!: Date
    completionDate!: Date
}
